export default "__VITE_ASSET__2ece74b0__"